// src/services/sinch.js
import axios from 'axios';

class SinchService {
  constructor() {
    this.apiUrl = process.env.VITE_FIREBASE_FUNCTIONS_BASE_URL; // Ensure this is set correctly
  }

  async makeCall(toNumber, text) {
    try {
      const response = await axios.post(`${this.apiUrl}/makeCall`, { toNumber, text });
      return response.data;
    } catch (error) {
      console.error('Error making call:', error);
      throw new Error('Failed to initiate the call.');
    }
  }

  async saveLog(logData) {
    try {
      const response = await axios.post(`${this.apiUrl}/saveSinchLog`, logData);
      return response.data;
    } catch (error) {
      console.error('Error saving Sinch log:', error);
      throw new Error('Failed to save log.');
    }
  }

  async fetchOnlineAgents() {
    try {
      const response = await axios.get(`${this.apiUrl}/fetchOnlineAgents`);
      return response.data;
    } catch (error) {
      console.error('Error fetching online agents:', error);
      throw new Error('Failed to fetch online agents.');
    }
  }

  async answerCall(callId) {
    try {
      const response = await axios.post(`${this.apiUrl}/answerCall`, { callId });
      return response.data;
    } catch (error) {
      console.error('Error answering call:', error);
      throw new Error('Failed to answer call.');
    }
  }

  async endCall(callId) {
    try {
      const response = await axios.post(`${this.apiUrl}/endCall`, { callId });
      return response.data;
    } catch (error) {
      console.error('Error ending call:', error);
      throw new Error('Failed to end call.');
    }
  }

  async transferCall(callId, agentId) {
    try {
      const response = await axios.post(`${this.apiUrl}/transferCall`, { callId, agentId });
      return response.data;
    } catch (error) {
      console.error('Error transferring call:', error);
      throw new Error('Failed to transfer call.');
    }
  }

  async sendSMS(toNumber, message) {
    try {
      const response = await axios.post(`${this.apiUrl}/sendSMS`, { toNumber, message });
      return response.data;
    } catch (error) {
      console.error("Error sending SMS:", error);
      throw new Error("Failed to send SMS.");
    }
  }

  async fetchSMSLogs() {
    try {
      const response = await axios.get(`${this.apiUrl}/fetchSMSLogs`);
      return response.data;
    } catch (error) {
      console.error("Error fetching SMS logs:", error);
      throw new Error("Failed to fetch SMS logs.");
    }
  }
}

export const sinchService = new SinchService();